// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomButton_root__keTn7","ribbon":"CustomButton_ribbon__uAJOm"};